import React from 'react';
import { CTAButton } from './CTAButton';
export function ProblemSection() {
  const problems = ['No sabes si intervenir o respetar su autonomía', 'Evitas conversaciones importantes porque no sabes cómo abordarlas', 'Sientes que todo el peso de las decisiones recae solo en ti', 'Hay tensión con tus hermanos o falta de organización familiar', 'Te preocupa lo que viene, pero no sabes cómo prepararte adecuadamente'];
  return <section className="bg-brand-dark text-white py-5 px-5" data-id="element-263">
      <div className="max-w-xl mx-auto" data-id="element-264">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-3 leading-tight" data-id="element-265">
          😩 ¿Estás viviendo esto...?
        </h2>
        <p className="text-center text-brand-yellow font-bold text-lg mb-8" data-id="element-266">
          Te va a sonar familiar:
        </p>

        <div className="space-y-3 mb-10" data-id="element-267">
          {problems.map((problem, idx) => <div key={idx} className="bg-gray-900 border border-gray-800 p-4 rounded-xl flex items-start gap-3" data-id="element-268">
              <span className="text-red-500 text-lg flex-shrink-0" data-id="element-269">❌</span>
              <p className="text-sm text-gray-300 font-medium leading-relaxed" data-id="element-270">
                {problem}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-271">
          <h3 className="text-xl md:text-2xl font-bold text-brand-yellow mb-6" data-id="element-272">
            ¿Cuánto tiempo más vas a seguir viviendo esta etapa sin claridad?
          </h3>
        </div>
      </div>
    </section>;
}